module.exports = __webpack_public_path__ + "static/Couleurs-73f72b110c6d2fd70a51e813b030adda.mp3";